// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A1kz","col":"styles_col__12dQY"};